export const STAGES = [
  { key: "idea_initiation", name: "Idea Initiation", short: "Idea", color: "#38BDF8", ai: "Relevance Scorer", owner_roles: ["AI"] },
  { key: "vector_validation", name: "Vector Validation", short: "Vector", color: "#818CF8", ai: "Feasibility Analyst", owner_roles: ["AI"] },
  { key: "lab_incubation", name: "Lab Incubation", short: "Lab / POC", color: "#8B5CF6", ai: "POC Advisor", owner_roles: ["POD", "SPE"] },
  { key: "ai_council_review", name: "AI Council Review", short: "Council", color: "#F59E0B", ai: "Council Briefer", owner_roles: ["COUNCIL"] },
  { key: "production_pod", name: "Production Pod", short: "Production", color: "#22C55E", ai: "Enterprise Scorecard", owner_roles: ["SPE", "PM"] },
  { key: "adoption_scale", name: "Adoption & Scale", short: "Adoption", color: "#06B6D4", ai: "Feedback Synthesizer", owner_roles: ["ADOPTION"] },
];

export const STAGE_MAP = Object.fromEntries(STAGES.map((s) => [s.key, s]));

export const ROLE_LABELS = {
  PMO: "PMO",
  PM: "Product Manager",
  COUNCIL: "AI Council",
  POD: "Pod Lead / FDE",
  SPE: "Solution Architect",
  ADOPTION: "Customer Success",
};

export const HEALTH_STYLE = {
  on_track: { label: "On Track", cls: "text-success border-success/40 bg-success/10" },
  at_risk: { label: "At Risk", cls: "text-warning border-warning/40 bg-warning/10" },
  breached: { label: "SLA Breach", cls: "text-danger border-danger/40 bg-danger/10" },
  idle: { label: "Idle", cls: "text-muted-foreground border-border bg-muted" },
};

export function roleColor(role) {
  return {
    PMO: "#38BDF8", PM: "#22C55E", COUNCIL: "#F59E0B",
    POD: "#8B5CF6", SPE: "#06B6D4", ADOPTION: "#EC4899",
  }[role] || "#71717A";
}
